/* eslint-disable max-lines-per-function */
import { FieldBase } from '@/domain/mitarbeiter/features/anlageassistent/components/form/fieldComponents/FieldBase';
import { InfoButton } from '@/domain/mitarbeiter/features/anlageassistent/components/InfoButton';
import { DreiMonatsdurchschnittFields } from '@/domain/mitarbeiter/features/anlageassistent/content/Abwesenheiten/Stundenbewertung/DynamischeStundenbewertung/DreiMonatsDurchschnittFields';
import { WochendurchschnittFields } from '@/domain/mitarbeiter/features/anlageassistent/content/Abwesenheiten/Stundenbewertung/DynamischeStundenbewertung/WochendurchschnittFields';

import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import {
  DYNAMISCHE_ABWESENHEIT_ARTEN,
  DynamischeAbwesenheitArt,
} from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/dynamischeAbwesenheitstypen';
import { Body, RadioGroup, RadioGroupItem } from '@e2n/ui/v2';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';

export function DynamischeStundenbewertung() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const { ctx } = useAnlageassistentContext();
  const isAnzahlArbeitstageFlexibel =
    form.state.values.abwesenheiten.allgemein.anzahlArbeitstage === 'FLEXIBEL';
  return (
    <form.AppField
      name="abwesenheiten.allgemein.dynamisch"
      listeners={{
        onChange: () => {
          ctx.resetDependentFields('abwesenheiten.allgemein.dynamisch');
        },
      }}>
      {(field) => (
        <div className="relative">
          <FieldBase>
            <RadioGroup
              value={field.state.value}
              onValueChange={(val) =>
                field.handleChange(val as DynamischeAbwesenheitArt)
              }
              onBlur={field.handleBlur}>
              <RadioGroupItem
                value={DYNAMISCHE_ABWESENHEIT_ARTEN.tagesschnitt}
                id={field.name + DYNAMISCHE_ABWESENHEIT_ARTEN.tagesschnitt}
                label={t(
                  'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.tagesdurchschnitt.label',
                )}
                showDescription
                description={t(
                  'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.tagesdurchschnitt.description',
                )}
              />

              <RadioGroupItem
                value={DYNAMISCHE_ABWESENHEIT_ARTEN.wochenschnitt}
                id={field.name + DYNAMISCHE_ABWESENHEIT_ARTEN.wochenschnitt}
                disabled={isAnzahlArbeitstageFlexibel}
                label={
                  <div className="flex gap-1 items-center">
                    {t(
                      'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.wochendurchschnitt.label',
                    )}
                    {isAnzahlArbeitstageFlexibel && (
                      <InfoButton icon={faInfoCircle}>
                        <Body>
                          {t(
                            'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.infoDisabledOptionFlexibel',
                          )}
                        </Body>
                      </InfoButton>
                    )}
                  </div>
                }
                showDescription
                description={
                  <div className="flex flex-col gap-4">
                    {t(
                      'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.wochendurchschnitt.description',
                    )}
                    {field.state.value ===
                      DYNAMISCHE_ABWESENHEIT_ARTEN.wochenschnitt && (
                      <WochendurchschnittFields />
                    )}
                  </div>
                }
              />

              <RadioGroupItem
                value={DYNAMISCHE_ABWESENHEIT_ARTEN.drei_monatsschnitt}
                id={
                  field.name + DYNAMISCHE_ABWESENHEIT_ARTEN.drei_monatsschnitt
                }
                disabled={isAnzahlArbeitstageFlexibel}
                label={
                  <div className="flex gap-1 items-center">
                    {t(
                      'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.drei_monatsdurchschnitt.label',
                    )}
                    {isAnzahlArbeitstageFlexibel && (
                      <InfoButton icon={faInfoCircle}>
                        <Body>
                          {t(
                            'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.infoDisabledOptionFlexibel',
                          )}
                        </Body>
                      </InfoButton>
                    )}
                  </div>
                }
                showDescription
                description={
                  <div className="flex flex-col gap-5">
                    {t(
                      'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.drei_monatsdurchschnitt.description',
                    )}
                    {field.state.value ===
                      DYNAMISCHE_ABWESENHEIT_ARTEN.drei_monatsschnitt && (
                      <DreiMonatsdurchschnittFields />
                    )}
                  </div>
                }
              />

              <RadioGroupItem
                value={DYNAMISCHE_ABWESENHEIT_ARTEN['12_monatsschnitt']}
                id={
                  field.name + DYNAMISCHE_ABWESENHEIT_ARTEN['12_monatsschnitt']
                }
                label={t(
                  'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.12_monatsdurchschnitt.label',
                )}
                showDescription
                description={t(
                  'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.12_monatsdurchschnitt.description',
                )}
              />
            </RadioGroup>
          </FieldBase>
        </div>
      )}
    </form.AppField>
  );
}
